import { CSSProperties } from "react";
import { SxProps, Theme } from "@mui/material";

export const sx = {
  gridWrapper: {
    height: 420,
    width: 1,
  } as SxProps<Theme>,

  dataGrid: {
    "& .row-has-error": {
      backgroundColor: "#fff4f4",
    },
    "& .row-has-error:hover": {
      backgroundColor: "#ffe8e8",
    },
  } as SxProps<Theme>,

  createButton: {
    textTransform: "none",
    width: "79px",
    marginTop: "24px",
  } as SxProps<Theme>,

  formBackground: {
    background: "#fff",
  } as CSSProperties,
};
